import { Sender } from 'xstate';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import * as krakenModels from '../../../model/config/krakenModels';
import { LogicContext } from '../types';

export const watchHeaderActions = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<
        | {
            type: 'VIEW_HAMBURGER_MENU_CLICK';
            payload: {
              command: string;
            };
          }
        | {
            type: 'VIEW_HEADER_SEARCH_CLICK';
            payload: {
              path: string;
            };
          }
        | {
            type:
              | 'VIEW_PARTIAL_EVENT_CALLED'
              | 'VIEW_FEEDBACK_EVENT_CALLED'
              | 'VIEW_HELP_EVENT_CALLED';
            payload: { [key: string]: any };
          }
        | {
            type: 'WH_HEADER_INITIALIZED' | 'WH_HEADER_TIMEOUT';
          }
      >
    ) => {
      return krakenModels.headerWatcher({ callback });
    }
  );
